import { PopularRanking, Statistics } from "../../models/statistics";
import StatisticsEvent from "../events/StatisticsEvent";

//統計情報取得
export const GetStatisticsStarted = (startDate: String, endDate: String) =>
    ({
        type: StatisticsEvent.GetStatisticsStarted,
        startDate,
        endDate,
    } as const);

export const GetStatisticsCompleted = (statistics: Statistics) =>
    ({
        type: StatisticsEvent.GetStatisticsCompleted,
        statistics,
    } as const);

//ランキング情報取得
export const GetPopularRankingStarted = (startDate: String, endDate: String) =>
    ({
        type: StatisticsEvent.GetPopularRankingStarted,
        startDate,
        endDate,
    } as const);

export const GetPopularRankingCompleted = (popularRanking: PopularRanking) =>
    ({
        type: StatisticsEvent.GetPopularRankingCompleted,
        popularRanking,
    } as const);

// Slidestock統計情報取得
export const GetDocumentStatistics = (startDate: String, endDate: String) =>
    ({
        type: StatisticsEvent.GetDocumentStatisticsStarted,
        startDate,
        endDate,
    } as const);

export const GetDocumentStatisticsCompleted = (statistics: Statistics) =>
    ({
        type: StatisticsEvent.GetDocumentStatisticsCompleted,
        statistics,
    } as const);

// Slidestockランキング情報取得
export const GetDocumentPopularRanking = (startDate: String, endDate: String) =>
    ({
        type: StatisticsEvent.GetDocumentPopularRankingStarted,
        startDate,
        endDate,
    } as const);

export const GetDocumentPopularRankingCompleted = (popularRanking: PopularRanking) =>
    ({
        type: StatisticsEvent.GetDocumentPopularRankingCompleted,
        popularRanking,
    } as const);

// 統計情報の登録(ドキュメント）
export const SaveDocumentStatistics = (
    userId: number,
    documentId: number,
    documentTag: String,
    documentTitle: String,
    imageUrl: String
) =>
    ({
        type: StatisticsEvent.SaveDocumentStatisticsStarted,
        userId,
        documentId,
        documentTag,
        documentTitle,
        imageUrl,
    } as const);

export const SaveDocumentStatisticsCompleted = () =>
    ({
        type: StatisticsEvent.SaveDocumentStatisticsCompleted,
    } as const);
